import React from 'react';
import { motion } from 'framer-motion';
interface NavLinkProps {
  href: string;
  children: React.ReactNode;
}
const NavLink = ({
  href,
  children
}: NavLinkProps) => {
  return <motion.a href={href} className="relative text-sm text-muted-foreground hover:text-primary" whileHover="hover" data-id="element-34">
      {children}
      <motion.span className="absolute bottom-0 left-0 h-[2px] bg-primary rounded-full" initial={{
      width: 0,
      x: '50%'
    }} variants={{
      hover: {
        width: '100%',
        x: 0,
        transition: {
          type: "spring",
          stiffness: 400,
          damping: 25
        }
      }
    }} data-id="element-35" />
    </motion.a>;
};
export function Footer() {
  return <motion.footer id="resources" className="bg-white border-t border-gray-200/50 py-8" initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} viewport={{
    once: true
  }} data-id="element-36">
      <div className="container" data-id="element-37">
        {/* Main footer content */}
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-38">
          {/* Brand and tagline - left */}
          <div className="flex flex-col items-center md:items-start mb-6 md:mb-0" data-id="element-39">
            <span className="font-display text-lg text-primary" data-id="element-40">
              RealtyZen
            </span>
            <span className="text-sm text-muted-foreground mt-1" data-id="element-41">
              Made with ✦ in SF
            </span>
          </div>
          
          {/* Navigation links - right */}
          <nav className="flex space-x-8" data-id="element-42">
            <NavLink href="/privacy" data-id="element-43">Privacy</NavLink>
            <NavLink href="/terms" data-id="element-44">Terms</NavLink>
            <NavLink href="mailto:contact@realtyzen.ai" data-id="element-45">Contact</NavLink>
          </nav>
        </div>
        
        {/* Copyright - bottom */}
        <div className="text-center mt-8 pt-6 border-t border-border/50" data-id="element-46">
          <span className="text-xs text-muted-foreground" data-id="element-47">
            © 2025 RealtyZen. All rights reserved.
          </span>
        </div>
      </div>
    </motion.footer>;
}